// @ts-strict-ignore
import getWindow from './get-window'

export const executeScroll = (ref) => {
  const topOfTable = ref.current
  const yOffset = -10
  const y = topOfTable.getBoundingClientRect().top + getWindow().pageYOffset + yOffset
  getWindow().scrollTo({ top: y, behavior: 'smooth' })
}
